export const NOT_LOCAL_URL = 'https://map.agro.gov.kg/interactive-map-ws/'

//тестовый
export const TEST_URL = 'https://map.agro.gov.kg/interactive-map-ws/'
// export const TEST_URL = 'http://10.250.70.98:8080/interactive-map-ws/'
